import { render, staticRenderFns } from "./SampleBasket.vue?vue&type=template&id=3211aadb&scoped=true"
import script from "./SampleBasket.vue?vue&type=script&lang=ts"
export * from "./SampleBasket.vue?vue&type=script&lang=ts"
import style0 from "./SampleBasket.vue?vue&type=style&index=0&id=3211aadb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3211aadb",
  null
  
)

export default component.exports